import { Table } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { useDetailColumns } from '../hooks/useDetailColumns';
import { useDetailFormatData } from '../hooks/useDetailFormatData';
import { PerformanceAnalysisDetailResponseType } from '../types';

export interface PerformanceAnalysisDetailTableProps {
  data?: PerformanceAnalysisDetailResponseType;
  loading: boolean;
}

export function PerformanceAnalysisDetailTable({
  data: dataProp,
  loading,
}: PerformanceAnalysisDetailTableProps) {
  const columns = useDetailColumns();
  const data = useDetailFormatData(dataProp?.data ?? []);
  const { t } = useTranslation(
    TranslationsKeys.MANAGEMENT_TOOLS_PERFORMANCE_ANALYSIS,
  );

  const table = useMemo(() => {
    return t<
      string,
      {
        noResults: string;
      }
    >('tableDetail', {
      returnObjects: true,
    });
  }, [t]);

  return (
    <Table
      columns={columns}
      data={data}
      borderless={false}
      color="transparent"
      striped
      isLoadingResults={loading}
      noResultsText={table.noResults}
    />
  );
}
